import React from 'react';
import './Restaurant.css';
import { Row, Col, Typography, Spin, Card, Input, Button } from 'antd';
import razorpay from '../../assests/razorpay.svg';
import _ from 'lodash';
import { useNavigate } from 'react-router';

const DefxRazorpay = ({ editId }) => {
  const navigate = useNavigate();

  return (
    <Card
      style={{
        backgroundColor: '#f6f6f6',
        border: 'rgb(229, 229, 229,1)',
      }}
    >
      <Row gutter={[16, 16]} className='button'>
        <Col span={24} className='formRows'>
          <Typography className='formHeading'>
            Razor pay key ID&nbsp;:{' '}
            {process.env.REACT_APP_ENV === 'production'
              ? 'rzp_live_xnaeSdLkUvF9GJ'
              : 'rzp_test_56rglkZpRec925'}
          </Typography>
        </Col>
      </Row>
      <Row gutter={[16, 16]} className='button'>
        <Col span={24} className='formRows'>
          <Typography className='formHeading'>
            Razor pay key secret &nbsp;:{' '}
            {process.env.REACT_APP_ENV === 'production'
              ? 'ZdqZ6y3dpupHQAuFsccrc6U1'
              : 'c2eBPgVh48eVnsUKu1OHcN2W'}
          </Typography>
        </Col>
      </Row>
      <Row className='button'>
        <Col span={24}>
          <Row>
            <Col>
              <Button
                className='detailsButton'
                icon={<img src={razorpay} alt='props' />}
                onClick={() =>
                  navigate(`/restaurants/${editId}/razorpaySplitting`)
                }
              >
                Razorpay Splitting
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default DefxRazorpay;
